
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Produtos",

  methods: {
    ...mapActions("checkout", ["ADICIONA_DADOS_INTERNOS"]),
    adicionarDadosAoCheckout(dados) {
      this.ADICIONA_DADOS_INTERNOS(dados).then(() => {
        this.$router.push("/vendas/checkout");
      });
    },
  },

  computed: {
    ...mapGetters("products", ["PRODUTOS"]),
  },
};
